/*
 *******************************************************************************
 * 
 *  Filename:   ./reducer.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers take dispatch results and apply them to the state.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 8:52 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      09/17/2018  NJN     Add Components and Component Pages
 *      09/18/2018  NJN     Add Navs
 *      09/25/2018  NJN     Add BlockValidationTypeFields
 *      09/27/2018  NJN     Add BlockElementOptions, BlockElementTypes, BlockGroups
 *      09/30/2018  NJN     Add Blocks, BlockElements
 *      10/28/2018  NJN     Add BlockDatas
 *      11/14/2018  NJN     Add BlockFormats, BlockFormatLevels
 *      11/19/2018  NJN     Add Folders
 *      12/02/2018  NJN     Add FileTypes
 *      12/03/2018  NJN     Add Contacts
 *      01/21/2019  NJN     Add Consequences
 *      01/21/2019  NJN     Add Probabilities
 *      01/21/2019  NJN     Add RiskClasses
 *      01/21/2019  NJN     Add RiskMatrix
 *      01/21/2019  NJN     Add Assets
 *      03/05/2019  NJN     Add Field Set Groups, Field Sets, Fields
 *      04/01/2019  NJN     Add GCSEquipments, Inspections
 *      05/13/2019  NJN     Add Location States, Countries, Counties, Zip Codes
 *      06/15/2019  NJN     Add Projects, Versions
 *      06/27/2019  NJN     Add Project_ProjectJobs
 *      07/06/2019  NJN     Add GoCampaign_PoliticalDistrictGroups, LocationCities
 *      07/10/2019  NJN     Add GoCampaign_PoliticalDistricts
 *      07/11/2019  NJN     Add GoCampaign_OfficeGroups
 *      09/29/2019  NJN     Add GoCampaign_PrecinctGroups, VoterDB_Voters
 *      10/26/2019  NJN     Add GoCampaign_Counties, GoCampaign_Precincts
 *      12/09/2019  NJN     Add ExportTypes, ExportTypeFilters, ExportJobs
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { reducer as toastr } from 'react-redux-toastr';
import { routerReducer } from 'react-router-redux';

import auth from './reducers/auth';
import register from './reducers/register';
import common from './reducers/common';

import Home from './reducers/Home';

import Companies from './reducers/Companies';
import CompanyStatuses from './reducers/CompanyStatuses';
import Users from './reducers/Users';
import UserStatuses from './reducers/UserStatuses';

import SystemDataTypes from './reducers/SystemDataTypes';
import FileTypes from './reducers/reducerFileTypes';
import SystemListGroups from './reducers/SystemListGroups';
import SystemLists from './reducers/SystemLists';
import SystemListItems from './reducers/SystemListItems';
import SystemBlocks from './reducers/SystemBlocks';
import SystemBlockValidationTypes from './reducers/SystemBlockValidationTypes';
import BlockValidationTypeFields from './reducers/reducerBlockValidationTypeFields';
import BlockElementOptions from './reducers/reducerBlockElementOptions';
import BlockElementTypes from './reducers/reducerBlockElementTypes';
import BlockGroups from './reducers/reducerBlockGroups';
import Blocks from './reducers/reducerBlocks';
import BlockElements from './reducers/reducerBlockElements';
import BlockDatas from './reducers/reducerBlockDatas';
import BlockFormats from './reducers/reducerBlockFormats';
import BlockFormatLevels from './reducers/reducerBlockFormatLevels';
import AdminSettings from './reducers/reducerAdminSettings';
import FieldSetGroups from './reducers/reducerFieldSetGroups';
import FieldSets from './reducers/reducerFieldSets';
import Fields from './reducers/reducerFields';

/*  Advarion CMS */
import Folders from './reducers/reducerFolders';
import FolderTrees from './reducers/reducerFolderTrees';

/*  Advarion CRM */
import Contacts from './reducers/reducerContacts';
import LocationStates from './reducers/reducerLocationStates';
import LocationCountries from './reducers/reducerLocationCountries';
import LocationCounties from './reducers/reducerLocationCounties';
import LocationZipCodes from './reducers/reducerLocationZipCodes';
import LocationCities from './reducers/reducerLocationCities';

/*  Advarion Projects */
import Project_CommonData from './reducers/reducerProject_CommonData';
import Project_Projects from './reducers/reducerProject_Projects';
import Project_ProjectVersions from './reducers/reducerProject_ProjectVersions';
import Project_ProjectJobs from './reducers/reducerProject_ProjectJobs';

/* Common */
import Modals from './reducers/reducerModals';

/*  Gulf Crane Custom */
import Consequences from './reducers/reducerConsequences';
import Probabilities from './reducers/reducerProbabilities';
import RiskClasses from './reducers/reducerRiskClasses';
import RiskMatrix from './reducers/reducerRiskMatrix';
import Assets from './reducers/reducerAssets';
import GCSCommonData from './reducers/reducerGCSCommonData';
import GCSEquipments from './reducers/reducerGCSEquipments';
import GCSInspections from './reducers/reducerGCSInspections';

/* GoCampaign */
import GoCampaign_PoliticalDistrictGroups from './reducers/reducerGoCampaign_PoliticalDistrictGroups';
import GoCampaign_PoliticalDistricts from './reducers/reducerGoCampaign_PoliticalDistricts';
import GoCampaign_OfficeGroups from './reducers/reducerGoCampaign_OfficeGroups';
import GoCampaign_PrecinctGroups from './reducers/reducerGoCampaign_PrecinctGroups';
import GoCampaign_Precincts from './reducers/reducerGoCampaign_Precincts';
import GoCampaign_Counties from './reducers/reducerGoCampaign_Counties';

/* VoterDB */
import VoterDB_Voters from './reducers/reducerVoterDB_Voters';
import ExportTypes from './reducers/reducerExportTypes';
import ExportTypeFilters from './reducers/reducerExportTypeFilters';
import ExportJobs from './reducers/reducerExportJobs';

/*  Advarion Platform */
import EmailSettings from './reducers/EmailSettings';
import CurrentUserProfile from './reducers/CurrentUserProfile';
import Roles from './reducers/Roles';

import NavGroups from './reducers/NavGroups';
import Navs from './reducers/Navs';
import NavTypes from './reducers/NavTypes';
import ComponentGroups from './reducers/ComponentGroups';
import Components from './reducers/Components';
import ComponentPages from './reducers/ComponentPages';

export default combineReducers({
    auth,
    register,
    common,

    Home,

    Companies, CompanyStatuses,
    Users, UserStatuses,

    SystemDataTypes, FileTypes, SystemListGroups, SystemLists, SystemListItems,
    SystemBlocks, SystemBlockValidationTypes, BlockValidationTypeFields, BlockElementOptions, BlockElementTypes,
    BlockGroups, Blocks, BlockElements, BlockDatas, BlockFormats, BlockFormatLevels, AdminSettings,
    FieldSetGroups, FieldSets, Fields,

    Folders, FolderTrees,

    Contacts, LocationStates, LocationCountries, LocationCounties, LocationZipCodes, LocationCities, 

    Project_CommonData, Project_Projects, Project_ProjectVersions, Project_ProjectJobs, 

    Modals,

    Consequences, Probabilities, RiskClasses, RiskMatrix, Assets, GCSCommonData, GCSEquipments, GCSInspections,

    GoCampaign_PoliticalDistrictGroups, GoCampaign_PoliticalDistricts, GoCampaign_OfficeGroups, GoCampaign_PrecinctGroups,
    GoCampaign_Counties, GoCampaign_Precincts,

    VoterDB_Voters, ExportTypes, ExportTypeFilters, ExportJobs,

    EmailSettings, CurrentUserProfile, Roles,
    NavGroups, Navs, NavTypes, ComponentGroups, Components, ComponentPages, 

    form,
    toastr,
    router: routerReducer
});


// WEBPACK FOOTER //
// ./src/reducer.js